// extracted by mini-css-extract-plugin
module.exports = {"container":"CardAttractImage_container__PBNaI","image":"CardAttractImage_image__LsmiS","textContent":"CardAttractImage_textContent__btww5"};